
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <error-message [errors]="errors"></error-message>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="row qb-nav">
                <div class="col-3 col-sm-2 col-lg-1 text-right"><button class="btn btn-link" [ngClass]="{'disabled': pageNumber == 0}" (click)="pageDown()" data-toggle="tooltip" data-placement="top" title="Previous"><i class="fas fa-chevron-circle-left"></i></button></div>
                <div class="col-6 col-sm-8 col-lg-10">
                    <h5 class="text-center">Step {{pageNumber + 1}} of {{questionsModel?.length}}</h5>
                    <div class="progress progress-xs m-2 light" style="height: 10px;">
                        <div class="progress-bar bg-primary" role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100" [style.width.%]="progress">
                            <span class="sr-only">{{progress}}%</span>
                        </div>
                    </div>
                </div>
                <div class="col-3 col-sm-2 col-lg-1 text-left"><button class="btn btn-link" [ngClass]="{'disabled': pageNumber == questionsModel.length - 1}" (click)="pageUp()" data-toggle="tooltip" data-placement="top" title="Next"><i class="fas fa-chevron-circle-right"></i></button></div>
            </div>
        </div>
        <form (submit)="saveAndClose()" [formGroup]="form">
            <ng-container formArrayName="questionBanks">
                <div class="container">
                    <div class="row mt-5" *ngFor="let item of form.get('questionBanks')['controls']; let i = index;" [formGroupName]="i" id="qb{{i}}" [hidden]="i!=pageNumber">
                        <div class="col">
                            <section class="border rounded question-bank">
                                <header class="card-header">
                                    <h5 class="card-title text-muted">{{item.value.questionBankName}}</h5>
                                </header>
                                <div class="card-body py-5">
                                    <fieldset>
                                        <div class="panel-body">
                                            <div class="row row d-flex justify-content-center">
                                                <div class="col-12">
                                                    <ng-container *ngFor="let questionModel of item.value.questionsModel">
                                                        <app-dynamic-form-question [question]="questionModel" [form]="item.get('questions')"></app-dynamic-form-question>
                                                    </ng-container>
                                                </div>
                                            </div>
                                        </div>
                                    </fieldset>
                                </div>
                                <div class="p-3 text-end">
                                    <span class="text-danger me-5" *ngIf="!form.valid">Please answer all questions</span>
                                    <button class="btn btn-success" type="button" (click)="saveAndContinue()" *ngIf="pageNumber != questionsModel.length - 1">Save and continue to next step</button>
                                    <button class="btn btn-success" type="submit" [disabled]="!form.valid" *ngIf="pageNumber == questionsModel.length - 1">Save and close audit</button>
                                </div>
                            </section>
                        </div>
                    </div>
                </div>
            </ng-container>
        </form>
